import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const initRoutes = [{
  path: '/login',
  name: 'login',
  component: () => import('@/views/Login.vue'),
}];

const routers = new Router({
  mode: process.env.NODE_ENV == 'production' ? 'history' : 'history',
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: initRoutes,
});

export default routers;



// WEBPACK FOOTER //
// ./src/router/index.js